import ReactGA from 'react-ga4';
import { gAnalytics } from '../constants/Constants';

let isGAInitialized = false;

const isDevelopment = process.env.NODE_ENV === 'development';

export const initializeGAWithConsent = () => {
  if (isGAInitialized) {
    return;
  }

  if (typeof (window as any).CookieConsent !== 'undefined') {
    const analyticsCategory = (window as any).CookieConsent.config.categories.analytics;

    if (analyticsCategory && analyticsCategory.wanted === true) {
      const gaTrackingId = gAnalytics.googleAnalyticsTrackingId;
      ReactGA.initialize(gaTrackingId, {
        gtagOptions: {
          debug_mode: false,
          send_page_view: false,
        },
      });

      isGAInitialized = true;
    }
  }
};

export const sendGAEvent = eventData => {
  if (typeof (window as any).CookieConsent !== 'undefined') {
    const analyticsCategory = (window as any).CookieConsent.config.categories.analytics;
    if (analyticsCategory && analyticsCategory.wanted === true) {
      if (!isGAInitialized) {
        initializeGAWithConsent();
      }
      if (isGAInitialized) {
        const eventName = eventData?.event_name || eventData?.action || 'interaction';
        const eventParams = {
          ...eventData,
          event_name: undefined,
          action: undefined,
        };

        if (typeof (window as any).gtag === 'function') {
          (window as any).gtag('event', eventName, eventParams);
        } else {
          ReactGA.event({
            action: eventName,
            ...eventParams,
          });
        }
      }
    }
  }
};

export const sendGAPageview = pageData => {
  if (typeof (window as any).CookieConsent !== 'undefined') {
    const analyticsCategory = (window as any).CookieConsent.config.categories.analytics;
    if (analyticsCategory && analyticsCategory.wanted === true) {
      if (!isGAInitialized) {
        initializeGAWithConsent();
      }
      if (isGAInitialized) {
        ReactGA.send(pageData);
      }
    }
  }
};

export const hasAnalyticsConsent = () => {
  if (typeof (window as any).CookieConsent !== 'undefined') {
    const analyticsCategory = (window as any).CookieConsent.config.categories.analytics;
    return analyticsCategory && analyticsCategory.wanted === true;
  }
  return false;
};

export const setupConsentListener = (userId = null) => {
  const checkAndSetupListener = () => {
    if (typeof (window as any).CookieConsent !== 'undefined') {
      const analyticsCategory = (window as any).CookieConsent.config.categories.analytics;

      if (analyticsCategory && analyticsCategory.wanted === true) {
        initializeGAWithConsent();
      }

      document.addEventListener('click', event => {
        const target = event.target as HTMLElement;

        if (
          target.classList.contains('consent-give') ||
          target.classList.contains('ccm__footer') ||
          target.textContent?.includes('Accept all cookies') ||
          target.textContent?.includes('Save current settings')
        ) {
          setTimeout(() => {
            initializeGAWithConsent();

            if (userId && typeof (window as any).syncCookieConsentWithCognito === 'function') {
              const cookiePreferences = {
                categories: (window as any).CookieConsent.config.categories,
              };
              (window as any).syncCookieConsentWithCognito(userId, cookiePreferences);
            }
          }, 200);
        }
      });
    } else {
      setTimeout(checkAndSetupListener, 100);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndSetupListener);
  } else {
    checkAndSetupListener();
  }
};

export const clearConsentCookies = () => {
  const cookies = document.cookie.split(';');
  cookies.forEach(cookie => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    if (name.includes('consent') || name.includes('cookie') || name.includes('_ga')) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
    }
  });

  Object.keys(localStorage).forEach(key => {
    if (key.includes('consent') || key.includes('cookie')) {
      localStorage.removeItem(key);
    }
  });
};

if (typeof window !== 'undefined') {
  (window as any).clearConsentCookies = clearConsentCookies;
}
